import { render, staticRenderFns } from "./contentCategoryEdit.vue?vue&type=template&id=0b30a2e4&"
import script from "./contentCategoryEdit.vue?vue&type=script&lang=js&"
export * from "./contentCategoryEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports